import LineEyeIcon from 'components/Luxkit/Icons/line/LineEyeIcon'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const ViewsBanner = styled(Group)`
  padding: ${rem(8)};
  color: ${props => props.theme.palette.highlight.tertiary.normalForeground};
  background-color: ${props => props.theme.palette.highlight.tertiary.lightBackground};
`

interface Props {
  numberOfViews: number
}

function FlashHotelViewsUrgencyBanner(props: Props) {
  const { numberOfViews } = props

  return <ViewsBanner direction="vertical" horizontalAlign="center" verticalAlign="center">
    <CaptionTextBlock variant="medium" weight="bold" startIcon={<LineEyeIcon />}>
      {numberOfViews} people viewed this offer today
    </CaptionTextBlock>
  </ViewsBanner>
}

export default FlashHotelViewsUrgencyBanner
